const replaceData = [
  { before : '\\lt', after : '<' },
  { before : '\\gt', after : '>' }
];

const appendQData = [
  '\\le',
  '\\ge'
];

const insertBraceData = [
  '^'
];

const useAnswer = () => {

  const replace = ( result, value ) => {
    if ( -1 < result.indexOf( value.before ) ) {
      return result.split( value.before ).join( value.after );
    } else {
      return result;
    }
  };

  const appendQ = ( result, value ) => {
    if ( -1 < result.indexOf( value ) ) {
      const mapResult = ( v, i ) => {
        switch ( true ) {
          case ! i :
          case 0 === v.indexOf( 'f' ) :
          case 0 === v.indexOf( 'q' ) :
            return v;
          default :
            return `q${ v }`;
        }
      };
      return result.split( value ).map( mapResult ).join( value );
    } else {
      return result;
    }
  };

  const insertBrace = ( result, value ) => {
    if ( -1 < result.indexOf( value ) ) {
      return result.split( value ).map( ( v, i ) => i && 0 !== v.indexOf( '{' ) ? `{${ v.slice( 0, 1 ) }}${ v.slice( 1 ) }` : v ).join( value );
    } else {
      return result;
    }
  };

  const convertAnswer = ( answer ) => {
    let convertedAnswer = answer.join( ';' );
    convertedAnswer = replaceData.reduce( replace, convertedAnswer );
    convertedAnswer = appendQData.reduce( appendQ, convertedAnswer );
    convertedAnswer = insertBraceData.reduce( insertBrace, convertedAnswer );
    return convertedAnswer;
  };

  return { convertAnswer };

};

export default useAnswer;
